import { SVCheckbox, SVCurrencyInput } from '@/components/core';
import { BankAccountEditFormValues } from '@/types/bankAccounts';
import { Card, Grid, Typography } from '@mui/material';
import { useFormContext } from 'react-hook-form';

export default function BankAccountEditFormFees() {
  const formMethods = useFormContext<BankAccountEditFormValues>();
  const [
    incomingDomesticUseCompanySetting,
    outgoingDomesticUseCompanySetting,
    savingsAccountUseCompanySetting,
  ] = formMethods.watch([
    'incomingDomesticFee.useCompanySetting',
    'outgoingDomesticFee.useCompanySetting',
    'savingsAccountFee.useCompanySetting',
  ]);

  return (
    <Card>
      <Typography variant="h5" mb={2}>
        Fees
      </Typography>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Typography fontWeight="bold">Incoming Domestic Wire Fee</Typography>
          <SVCheckbox
            label="Use Company Setting"
            name="incomingDomesticFee.useCompanySetting"
          />
          <SVCurrencyInput
            label="Incoming Domestic Wire Fee"
            name="incomingDomesticFee.fee"
            disabled={incomingDomesticUseCompanySetting}
            hideLabel
            rules={{ required: !incomingDomesticUseCompanySetting }}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Typography fontWeight="bold">Outgoing Domestic Wire Fee</Typography>
          <SVCheckbox
            label="Use Company Setting"
            name="outgoingDomesticFee.useCompanySetting"
          />
          <SVCurrencyInput
            label="Outgoing Domestic Wire Fee"
            name="outgoingDomesticFee.fee"
            disabled={outgoingDomesticUseCompanySetting}
            hideLabel
            rules={{ required: !outgoingDomesticUseCompanySetting }}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Typography fontWeight="bold">Monthly Savings Account Fee</Typography>
          <Typography variant="body2">
            The fee will be the same for an individual, joint, and business
            account.
          </Typography>
          <SVCheckbox
            label="Use Company Setting"
            name="savingsAccountFee.useCompanySetting"
          />
          <SVCurrencyInput
            label="Monthly Savings Account Fee"
            name="savingsAccountFee.fee"
            disabled={savingsAccountUseCompanySetting}
            hideLabel
            rules={{ required: !savingsAccountUseCompanySetting }}
          />
        </Grid>
      </Grid>
    </Card>
  );
}
